import { inject, Pipe, PipeTransform } from '@angular/core';
import { IconProviderService } from '../../../whitelabel/services/icon-provider.service';
import { FileTypeIconPipe } from '../../../shared/pipes/file-type-icon.pipe';
import { ViewReportDefinition } from '../contract/view-report-definition.contract';
import { IconKey } from '../../../../whitelabel/icon-key.enum';


@Pipe({
  name: 'getReportIcon',
  standalone: true,
})
export class GetReportIconPipe implements PipeTransform {
  private iconProviderService = inject(IconProviderService);
  private fileTypeIconPipe = inject(FileTypeIconPipe);

  private readonly isFontAwesome = (iconKey: string): boolean => {
    if (!iconKey) return false;
    return /^(fa-(solid|regular|light|thin|duotone|brands)\s+fa-[\w-]+|fa[slrtdb]\s+fa-[\w-]+|fa-[\w-]+)$/.test(iconKey);
  };

  transform(report: ViewReportDefinition): string {
    const iconKey = report.reportDefinitionIconKey;

    if (!iconKey) {
      return this.fileTypeIconPipe.transform(report.reportDefinitionExportFormat);
    }

    return this.isFontAwesome(iconKey) ? iconKey : this.iconProviderService.getIcon(IconKey.ReportCardDefaultIcon);
  }
}
